exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-arkisto-js": () => import("./../../../src/pages/arkisto.js" /* webpackChunkName: "component---src-pages-arkisto-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kirjoituksia-js": () => import("./../../../src/pages/kirjoituksia.js" /* webpackChunkName: "component---src-pages-kirjoituksia-js" */)
}

